var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word-wrap"},[_c('div',{attrs:{"id":"wordView"},domProps:{"innerHTML":_vm._s(_vm.wordText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }